<template>
  <div
    :class="[
      'canvas-filter',
      {
        maskRight:
          slideAmount > 1 &&
          selectedChipIndex === 0 &&
          selectedChipIndex < slideAmount - 1
      },
      {
        maskLeftRight:
          slideAmount > 1 &&
          selectedChipIndex > 0 &&
          selectedChipIndex < slideAmount - 1
      },
      ,
      {
        maskLeft:
          slideAmount > 1 &&
          selectedChipIndex > 0 &&
          selectedChipIndex === slideAmount - 1
      }
    ]"
  >
    <img
      class="arrow-left"
      @click="selectedChipIndex = selectedChipIndex - 1"
      :src="
        `${baseUrl}assets/images/atoms-icons-actions-navigation-arrow-left.svg`
      "
      alt="arrow left"
    />
    <div :class="['canvas-filter-wrapper']">
      <TvaSlider
        :config="{
          arrows: false,
          dots: false,
          options: {
            draggable: '>1',
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            lazyLoad: 2,
            adaptiveHeight: true,
            fade: false,
            groupCells: true
          }
        }"
        :key="getCountry"
        @click="click"
        @change="selectedChipIndex = $event"
        @setSlideAmount="slideAmount = $event"
        :sliderGoTo="selectedChipIndex"
        :style="{ transform: 'translateY(20px)' }"
      >
        <div
          class="museum"
          :data-museum="museum[0].museum"
          :data-museumid="museum[0].museumId"
          v-for="(museum, museumIndex) in museums"
          :key="museumIndex"
        >
          <div
            class="city"
            v-if="museum[0].id === cities[museum[0].city][0].id"
          >
            {{ museum[0].city }}
          </div>
          <div
            :title="museum[0].museum"
            :class="[
              'chip',
              {
                selected: getMuseum === museum[0].museum,
                unselected: getMuseum !== null
              }
            ]"
          >
            <span class="chip-label">{{ museum[0].museum }}</span
            ><span class="chip-value">{{ museum.length }}</span>
          </div>
        </div>
      </TvaSlider>
    </div>
    <img
      class="arrow-right"
      @click="selectedChipIndex = selectedChipIndex + 1"
      :src="
        `${baseUrl}assets/images/atoms-icons-actions-navigation-arrow-right.svg`
      "
      alt="arrow right"
    />
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import TvaSlider from "@/utilities/TvaSlider.vue";

export default {
  name: "canvas-filter",
  data() {
    return {
      slideAmount: 0,
      selectedChipIndex: 0,
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {
    filteredData() {
      return _.filter(this.$ml.get("data"), d => d.country === this.getCountry);
    },
    cities() {
      return _.groupBy(this.filteredData, "city");
    },
    museums() {
      return _.groupBy(this.filteredData, "museum");
    },
    ...mapGetters(["getCountry", "getMuseum", "getMuseumId"])
  },
  methods: {
    click(element, index) {
      let museum = element.dataset.museum;
      let museumId = +element.dataset.museumid;
      this.setMuseum(this.getMuseum === museum ? null : museum);
      this.setMuseumId(this.getMuseumId === museumId ? null : museumId);
    },
    ...mapActions(["setMuseum", "setMuseumId"])
  },
  components: {
    TvaSlider
  }
};
</script>

<style lang="scss" scoped>
.canvas-filter {
  width: 100%;
  position: relative;
  max-width: $max-width;
  width: 100%;
  margin: 0 auto;
  pointer-events: initial;
  .arrow-left,
  .arrow-right {
    position: absolute;
    bottom: 5px;
    display: none;
    z-index: 1;
    cursor: pointer;
  }
  .arrow-right {
    right: 0;
  }
  .canvas-filter-wrapper {
    position: relative;
    user-select: none;
    height: 50px;

    display: flex;
    align-items: flex-end;
    overflow: hidden;
    padding: 40px 0;
    transform: translateY(20px);
    transition: mask-image 0.2s ease;

    .museum {
      bottom: 0;
      .city {
        text-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
        @include h4-desktop-left;
      }
      .chip {
        margin-right: 10px;
      }
    }
  }
  &.maskRight {
    .canvas-filter-wrapper {
      mask-image: linear-gradient(
        to right,
        rgba(0, 0, 0, 1) 90%,
        rgba(0, 0, 0, 0) 100%
      );
    }
    .arrow-right {
      display: block;
    }
  }
  &.maskLeft {
    .canvas-filter-wrapper {
      mask-image: linear-gradient(
        to left,
        rgba(0, 0, 0, 1) 90%,
        rgba(0, 0, 0, 0) 100%
      );
    }

    .arrow-left {
      display: block;
    }
  }
  &.maskLeftRight {
    .canvas-filter-wrapper {
      mask-image: linear-gradient(
        to right,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 1) 10%,
        rgba(0, 0, 0, 1) 90%,
        rgba(0, 0, 0, 0) 100%
      );
    }
    .arrow-left,
    .arrow-right {
      display: block;
    }
  }
}
</style>
